import { EventSearchQuery, EventsInfo } from './reducer';

export enum TypeKeys {
    SWITCH_CONTEXT = 'detailsPanel/SWITCH_CONTEXT',
    CLOSE_DETAILS_PANEL = 'detailsPanel/CLOSE_DETAILS_PANEL',
    EVENTS_LOADED = 'detailsPanel/EVENTS_LOADED',
    UPDATE_EVENTS_SEARCH_QUERY = 'detailsPanel/UPDATE_EVENTS_SEARCH_QUERY',
}

export interface SwitchContextAction {
    type: TypeKeys.SWITCH_CONTEXT;
    context: string;
    featureId: string;
}

export interface CloseDetailsPanelAction {
    featureId: string;
    type: TypeKeys.CLOSE_DETAILS_PANEL;
}

export interface EventsLoadedAction {
    featureId: string;
    type: TypeKeys.EVENTS_LOADED;
    eventsInfo: EventsInfo;
}

export interface UpdateEventsSearchQuery {
    featureId: string;
    type: TypeKeys.UPDATE_EVENTS_SEARCH_QUERY;
    searchQuery: EventSearchQuery;
}

export type ActionTypes = SwitchContextAction | CloseDetailsPanelAction |
    EventsLoadedAction | UpdateEventsSearchQuery;

export const onCloseDetailsPanel = (featureId: string): CloseDetailsPanelAction => ({
    featureId,
    type: TypeKeys.CLOSE_DETAILS_PANEL,
});

export const onSwitchDetailsContext = (featureId: string, context: string): SwitchContextAction => ({
    featureId,
    context,
    type: TypeKeys.SWITCH_CONTEXT,
});

export const onEventLoaded = (featureId: string, eventsInfo: EventsInfo): EventsLoadedAction => ({
    featureId,
    eventsInfo,
    type: TypeKeys.EVENTS_LOADED,
});

export const updateEventSearchQuery = (featureId: string, searchQuery: EventSearchQuery): UpdateEventsSearchQuery => ({
    featureId,
    searchQuery,
    type: TypeKeys.UPDATE_EVENTS_SEARCH_QUERY,
});
